import { EditPasswordlessAccessModel } from 'app/library/passwordless-access/models/edit-passwordless-access';
import { ICreateEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/create-entity-failure-payload.interface';
import { IFetchEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/fetch-entity-failure-payload.interface';
import { CreateModulePasswordlessAccessModel } from '../models/create-module-passwordless-access';
import { ModulePasswordlessAccess } from '../models/module-passwordless-access.model';

export class SetModulePasswordlessAccess {
    static readonly type = '[ModulePasswordlessAccess] SetModulePasswordlessAccess';

    constructor(public payload: ModulePasswordlessAccess) {}
}

export class UnsetModulePasswordlessAccess {
    static readonly type = '[ModulePasswordlessAccess] UnsetModulePasswordlessAccess';
}

export class FetchModulePasswordlessAccess {
    static readonly type = '[ModulePasswordlessAccess] FetchModulePasswordlessAccess';

    constructor(public payload: string) {}
}

export class AddModulePasswordlessAccesses {
    static readonly type = '[ModulePasswordlessAccess] AddModulePasswordlessAccesses';

    constructor(public payload: ModulePasswordlessAccess[]) {}
}

export class FetchModulePasswordlessAccessSuccess {
    static readonly type = '[ModulePasswordlessAccess] FetchModulePasswordlessAccessSuccess';

    constructor(public payload: ModulePasswordlessAccess) {}
}

export class FetchModulePasswordlessAccessFailure {
    static readonly type = '[ModulePasswordlessAccess] FetchModulePasswordlessAccessFailure';

    constructor(public payload: IFetchEntityFailureActionPayload) {}
}

export class CreateModulePasswordlessAccess {
    static readonly type = '[ModulePasswordlessAccess] CreateModulePasswordlessAccess';

    constructor(public payload: CreateModulePasswordlessAccessModel) {}
}

export class CreateModulePasswordlessAccessSuccess {
    static readonly type = '[ModulePasswordlessAccess] CreateModulePasswordlessAccessSuccess';

    constructor(public payload: ModulePasswordlessAccess[]) {}
}

export class CreateModulePasswordlessAccessFailure {
    static readonly type = '[ModulePasswordlessAccess] CreateModulePasswordlessAccessFailure';

    constructor(public payload: ICreateEntityFailureActionPayload) {}
}

export class UpdateModulePasswordlessAccess {
    static readonly type = '[ModulePasswordlessAccess] UpdateModulePasswordlessAccess';

    constructor(public payload: EditPasswordlessAccessModel) {}
}

export class UpdateModulePasswordlessAccessSuccess {
    static readonly type = '[ModulePasswordlessAccess] UpdateModulePasswordlessAccessSuccess';

    constructor(public payload: ModulePasswordlessAccess[]) {}
}

export class UpdateModulePasswordlessAccessFailure {
    static readonly type = '[ModulePasswordlessAccess] UpdateModulePasswordlessAccessFailure';
}

export class DeleteModulePasswordlessAccess {
    static readonly type = '[ModulePasswordlessAccess] DeleteModulePasswordlessAccess';

    constructor(public payload: string[]) {}
}

export class DeleteModulePasswordlessAccessSuccess {
    static readonly type = '[ModulePasswordlessAccess] DeleteModulePasswordlessAccessSuccess';

    constructor(public payload: string[]) {}
}

export class DeleteModulePasswordlessAccessFailure {
    static readonly type = '[ModulePasswordlessAccess] DeleteModulePasswordlessAccessFailure';
}

export class SendModulePasswordlessAccess {
    static readonly type = '[ModulePasswordlessAccess] SendModulePasswordlessAccess';

    constructor(
        public payload: {
            accessIds: string[];
            subject: string;
            message: string;
        }
    ) {}
}

export class SendModulePasswordlessAccessSuccess {
    static readonly type = '[ModulePasswordlessAccess] SendModulePasswordlessAccessSuccess';

    constructor(public payload: string) {}
}

export class SendModulePasswordlessAccessFailure {
    static readonly type = '[ModulePasswordlessAccess] SendModulePasswordlessAccessFailure';
}

export class SetModulePasswordlessAccesses {
    static readonly type = '[ModulePasswordlessAccess] SetModulePasswordlessAccesses';

    constructor(public payload: ModulePasswordlessAccess[]) {}
}

export class FetchModulePasswordlessAccesses {
    static readonly type = '[ModulePasswordlessAccess] FetchModulePasswordlessAccesses';

    constructor(
        public payload: {
            moduleId: string;
            pageSize: number;
            pageNumber: number;
            search: string;
        }
    ) {}
}

export class FetchModulePasswordlessAccessesSuccess {
    static readonly type = '[ModulePasswordlessAccess] FetchModulePasswordlessAccessesSuccess';

    constructor(public payload: ModulePasswordlessAccess[]) {}
}

export class FetchModulePasswordlessAccessesFailure {
    static readonly type = '[ModulePasswordlessAccess] FetchModulePasswordlessAccessesFailure';
}

export class ToggleSelectedModulePasswordlessAccess {
    static readonly type = '[ModulePasswordlessAccess] ToggleSelectedModulePasswordlessAccess';

    constructor(public payload: string) {}
}

export class SelectFilteredModulePasswordlessAccesses {
    static readonly type = '[ModulePasswordlessAccess] SelectFilteredModulePasswordlessAccesses';
}

export class DeselectSelectedModulePasswordlessAccesses {
    static readonly type = '[ModulePasswordlessAccess] DeselectSelectedModulePasswordlessAccesses';
}

export class SearchModulePasswordlessAccesses {
    static readonly type = '[ModulePasswordlessAccess] SearchModulePasswordlessAccesses';

    constructor(public payload: string) {}
}
